import axios from "axios";
import utils from "../utils";
import { Message } from "element-ui";
import moment from "moment";
// import ERROR_TYPE from "src/config";
const request = axios.create();
let copyConfig = {};
request.interceptors.request.use(
  config => {
    // 设置 header
    var headerData = utils.getRequestHeader();
    if (config.url === "api/server/serverLoginAuth") {
      const { search } = window.location;
      let loginToken, productId;
      if (search.match(/loginToken/)) {
        let strArr = search.slice(1).split("&");
        strArr = strArr.map(ele => {
          return decodeURIComponent(ele);
        });
        strArr.forEach(item => {
          if (item.match(/loginToken/)) {
            loginToken = item.split("=")[1];
          } else if (item.match(/productId/)) {
            productId = item.split("=")[1];
          }
        });
      } else {
        loginToken = sessionStorage.getItem("loginToken");
        productId = sessionStorage.getItem("productId");
      }
      headerData.token = loginToken;
      headerData.productId = productId;
    }

    // 导出
    if (config.url.indexOf("/api/cusServer/exportExcel") >= 0) {
      config.responseType = "blob";
    }

    // 下单接口超时处理
    if (config.url === "/api/recharge/payment") {
      config.timeout = 300000;
    } else if (config.url.includes("queryDomainName")) {
      config.timeout = 2000;
    } else {
      config.timeout = 10000;
    }

    config.headers = {
      ...headerData
    };
    copyConfig = { ...config };

    console.log({
      postUrl: copyConfig.url,
      postParams: copyConfig.data
    });

    if (config["Content-Type"] === "multipart/form-data;charset=utf-8") {
      // 上传文件时，指定config中Content-Type为multipart/form-data;charset=utf-8
      // do nothing
    } else {
      if (config.method === "post") {
        console.log({
          postParams: config.data,
          url: config.url
        });
        config.data = {
          encryptParam: utils.RSAEncrypt(JSON.stringify(config.data))
        };
      }
    }
    return config;
  },
  error => {
    console.log(error);
    console.log("请求错误");
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  response => {
    let res = response.data;
    utils.log(
      "api 服务器时间",
      moment(response.headers.date).format("YYYY-MM-DD HH:mm:ss")
    );
    return res;
  },
  async error => {
    console.log(error);
    // Axios 0.19 cancellation errors do not carry the originating config.
    // Cancellation is control flow and must never surface a network toast.
    if (axios.isCancel(error) || (error && error.__CANCEL__ === true)) {
      return Promise.reject(error);
    }
    // Reconciliation is a background repair loop. Its caller owns retries and
    // diagnostics, so it must not show a user-facing toast every poll cycle.
    if (error && error.config && error.config.suppressUserError === true) {
      return Promise.reject(error);
    }
    let code = 0;
    // const device = utils.getdev();
    try {
      code = error.response.data.status;
    } catch (e) {
      console.log(e);
      console.log("响应错误");
      if (error.toString().indexOf("Error: timeout") !== -1) {
        Message.closeAll();
        Message.error({
          message: "响应过慢，请确认网络",
          duration: 5000
        });
        // return Promise.reject(error);
        if (copyConfig.url === "/api/user/msg") {
          return false;
        }
        return Promise.reject(error);
      }
    }
    // setTimeout(() => {
    //   utils.getlog({
    //     appId: device,
    //     // productId: commonCanstant.PRODUCTID,
    //     productId: sessionStorage.getItem("productId"),
    //     time: new Date(),
    //     lever: ERROR_TYPE.ERROR_TYPE.FATAL,
    //     msg: JSON.stringify(error)
    //   });
    // }, 0);
    if (code) {
      if (copyConfig.url == "/api/common/collection") {
        return false;
      }
      if (code === 420) {
        console.log("420");
        if (copyConfig.url !== "/api/customer/end") {
          Message.closeAll();
          Message.warning(error.response.data.message);
        }
        // if (copyConfig.url === "/api/customer/channel") {
        //   Message.warning(error.response.data.message);
        // }
        return false;
      }

      if (code === 400) {
        if (error.response.data.message == "请求参数错误") {
          if (copyConfig.url === "/api/user/msg") {
            Message.closeAll();
            Message.warning("发送失败请重试！");
          }
          return false;
        }
        Message.closeAll();
        Message.warning(error.response.data.message);
        return;
      }
    }

    if (!window.navigator.onLine) {
      Message.closeAll();
      Message.warning("网络不佳，请确认本地网络");
      return Promise.reject(error);
    }
    if (error.response && error.response.status === 500) {
      Message.closeAll();
      Message.warning("响应过慢，请确认网络");
      return;
    }
    if (error.response && error.response.status === 506) {
      Message.closeAll();
      Message({
        message: "登录已失效，请重新进入！",
        type: "error",
        duration: 50000
      });
      return;
    }
    return Promise.reject(error);
  }
);

export default request;
